import React from "react";
import { Modal } from "react-bootstrap";
import ChangePasswordForm from "../../../Home/Forms/ChangePasswordForm";

const ChangePasswordModal = ({ show, onClose, user, onSubmit, t }) => {
    if (!show || !user) return null;

    return (
        <Modal size="md" centered backdrop="static" keyboard={false} show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <div className="h5 mb-0">
                        <i className="fad fa-key text-primary icon ml-2"></i>
                        {t("Pages.UsersControl.action.change_password")}:
                        <span className="text-primary mr-1">{user.Name}</span>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="widget widget-category">
                    <div className="widget-body">
                        <ChangePasswordForm onSubmit={onSubmit} />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ChangePasswordModal;
